import { createInertiaApp } from '@inertiajs/vue3'
// 按需加载不需要全局导入 ElementPlus
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import { createApp, h } from 'vue'
// 移除默认样式导入，使用自定义主题
// import 'element-plus/dist/index.css'
import '@/assets/styles/element-theme.scss'
import actioncable from '@/plugins/actioncable'
import i18n from '@/plugins/i18n'
import permissionDirective from '@/plugins/permission'
import posthogPlugin from '@/plugins/posthog'

createInertiaApp({
  progress: {
    delay: 250,
    color: '#722ED1', // 紫色，与系统主题一致
    includeCSS: true,
    showSpinner: false
  },
  title: (title) => (title ? `${title} - Lagent` : 'Lagent'),
  resolve: (name) => {
    const pages = import.meta.glob('../pages/**/*.vue', { eager: true })
    return pages[`../pages/${name}.vue`]
  },
  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(i18n)
      .use(permissionDirective)
      .use(actioncable)
      .use(posthogPlugin)
      .provide('elLocale', zhCn) // 提供中文语言配置
      .mount(el)
  }
})
